import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_my_einvoice_request_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  pin_code: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
  invoice_no: fromDatatype.VarcharDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  request_status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  access_key: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_my_einvoice_request_hdr_RowClass
  implements bl_fi_my_einvoice_request_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    pin_code: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
    invoice_no: fromDatatype.VarcharDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_name: fromDatatype.VarcharDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_name: fromDatatype.VarcharDatatypeInterface;
    request_status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    server_doc_2: fromDatatype.VarcharDatatypeInterface;
    server_doc_3: fromDatatype.VarcharDatatypeInterface;
    server_doc_4: fromDatatype.VarcharDatatypeInterface;
    server_doc_5: fromDatatype.VarcharDatatypeInterface;
    client_doc_1: fromDatatype.VarcharDatatypeInterface;
    client_doc_2: fromDatatype.VarcharDatatypeInterface;
    client_doc_3: fromDatatype.VarcharDatatypeInterface;
    client_doc_4: fromDatatype.VarcharDatatypeInterface;
    client_doc_5: fromDatatype.VarcharDatatypeInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    access_key: fromDatatype.VarcharDatatypeInterface;
    email: fromDatatype.VarcharDatatypeInterface;
}
